module.exports = __webpack_public_path__ + "img/mon_24.2dad710c.png";